module.exports = __webpack_public_path__ + "static/media/bell-icon.b79a9d31.svg";